/**
 * @protobufOption (description) = "Allows a retailer user to invite subusers"
 * @protobufOption (internalOnly) = false
 * @protobufOption (productArea) = USER_INVITATION
 * @protobufOption (title) = "Invite Retailer User"
 */ export var RETAILER_INVITE_ACCOUNT_USER = 'RETAILER_INVITE_ACCOUNT_USER';
export var Extensions = {
    productArea: "USER_INVITATION",
    title: "Invite Retailer User",
    description: "Allows a retailer user to invite subusers",
    internalOnly: false
};
